var map = {
	"./fonts/Manrope/Manrope-Bold.ttf": 6891,
	"./fonts/Manrope/Manrope-ExtraBold.ttf": 2565,
	"./fonts/Manrope/Manrope-Light.ttf": 6811,
	"./fonts/Manrope/Manrope-Medium.ttf": 5518,
	"./fonts/Manrope/Manrope-Regular.ttf": 9114,
	"./fonts/Manrope/Manrope-SemiBold.ttf": 7065,
	"./fonts/Oswald/Oswald-Bold.ttf": 8178,
	"./fonts/Oswald/Oswald-Light.ttf": 4143,
	"./fonts/Oswald/Oswald-Medium.ttf": 2060,
	"./fonts/Oswald/Oswald-Regular.ttf": 2509,
	"./fonts/Oswald/Oswald-SemiBold.ttf": 3304,
	"./images/jpg/ConsultingCoverOne.jpg": 53,
	"./images/jpg/ConsultingCoverTwo.jpg": 4855,
	"./images/jpg/ConsultingHead.jpg": 1533,
	"./images/jpg/MobileDetection.jpg": 7538,
	"./images/jpg/MobileDetection2.jpg": 9560,
	"./images/jpg/SectionOneImage.jpg": 3291,
	"./images/jpg/SectionTwoImage.jpg": 2792,
	"./images/jpg/SolutionsBanner.jpg": 9007,
	"./images/jpg/black-bg.jpg": 9293,
	"./images/jpg/branches-banner.jpg": 5250,
	"./images/jpg/more-info.jpg": 9504,
	"./images/jpg/s1.jpg": 158,
	"./images/png/ClientChart.png": 2392,
	"./images/png/logo-dark.png": 9123,
	"./images/png/logo.png": 4656,
	"./images/png/plane.png": 5551,
	"./images/png/sky.png": 7603,
	"./images/png/we-are-amstone.png": 3809,
	"./images/solutions/1.jpg": 7298,
	"./images/solutions/10.jpg": 5577,
	"./images/solutions/2.jpg": 7518,
	"./images/solutions/3.jpg": 541,
	"./images/solutions/4.jpg": 3489,
	"./images/solutions/5.jpg": 2342,
	"./images/solutions/6.jpg": 4969,
	"./images/solutions/7.jpg": 2920,
	"./images/solutions/8.jpg": 3234,
	"./images/solutions/9.jpg": 2587,
	"./images/svg/arrow.svg": 581,
	"./images/svg/pattern.svg": 7029,
	"./sounds/Military-Soundtrack.mp3": 508,
	"./videos/AMSTONE-HOME-VIDEO.mp4": 6579,
	"./videos/earth-technology-infographics-background.mp4": 8213,
	"./videos/masked-bg.mp4": 9441
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;